import {
  ACTIONS_APPROVE,
  ACTIONS_REJECT,
  ACTIONS_VIEW_ALL,
  ACTIONS_VIEW_TEAM_ACTIONS,
} from '@/config/permission';

export default function canSeePendingApprovalTab(can) {
  const hasActionVisibility = can(ACTIONS_VIEW_ALL) || can(ACTIONS_VIEW_TEAM_ACTIONS);

  return hasActionVisibility && can(ACTIONS_APPROVE) && can(ACTIONS_REJECT);
}
